import { ethereum } from '@0xtorch/core'
import { blast } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createRoutescan } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createBlastChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createBlastChainCustom({
    client: createClient({
      chain: blast,
      httpRpcs: blastHttpRpcs,
    }),
    // Etherscan V2 の対応 chain から外れたため、Routescan の Etherscan 互換 API を使う。
    explorer: createRoutescan({
      name: 'Blast Explorer',
      baseUrl: 'https://blastexplorer.io',
      chainId: 81_457,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateBlastChainParameters = {
  client: Client
  explorer: Explorer
}

export const createBlastChainCustom = ({
  client,
  explorer,
}: CreateBlastChainParameters): Chain => ({
  id: 81_457,
  network: 'blast',
  name: 'Blast',
  nativeToken: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    currency: ethereum,
  },
  wrappedTokenAddresses: new Set([
    '0x4300000000000000000000000000000000000004',
  ]),
  explorer,
  client,
  blockTime: 2000,
  coingeckoId: 'blast',
  defillamaId: 'blast',
})

export const blastHttpRpcs: HttpRpc[] = [
  {
    url: 'https://rpc.blast.io',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://blast.din.dev/rpc',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://blast.blockpi.network/v1/rpc/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 1024n,
  // },
  // Endpoint is not working
  // {
  //   url: 'https://blast.gasswap.org',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Endpoint is not working
  // {
  //   url: 'https://rpc.envelop.is/blast',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://blast-rpc.publicnode.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://blast.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://blast.gateway.tenderly.co',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const blastWebsocketRpcUrls: readonly string[] = [
  'wss://blast.gasswap.org',
  'wss://blast-rpc.publicnode.com',
  'wss://blast.drpc.org',
  'wss://blast.callstaticrpc.com',
]
